import React from 'react';

export function UniqueFeature({ ...props }) {
  const {
          label,
          image,
          link,
        } = props;

  if (typeof link === 'string' && link.length > 0) {
    return (
      <a href={link} target={'_blank'} className={'item feature'}>
        <picture>
          <img
            src={image}
            alt={label}
          />
        </picture>
        <div className={'title'}>{label}</div>
      </a>
    );
  }

  return (
    <div className={'item feature'}>
      <picture>
        <img
          src={image}
          alt={label}
        />
      </picture>
      <div className={'title'}>{label}</div>
    </div>
  );
}